import axios from 'axios';

const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_SOCKET,
});

// Add a request interceptor
api.interceptors.request.use(config => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// Add a response interceptor
api.interceptors.response.use(response => {
  return response;
}, async error => {
  const originalRequest = error.config;

  // Don't retry login or 2FA endpoints
  const isAuthEndpoint = originalRequest.url?.includes('/api/login');

  if (error.response && error.response.status === 401 && !originalRequest._retry && !isAuthEndpoint) {
    originalRequest._retry = true;
    const refreshToken = localStorage.getItem('refresh_token');

    // Pas de jeton de rafraichissement = il n'y a jamais eu de session. Ce 401
    // est celui d'un VISITEUR, pas celui d'une session expiree : on le laisse
    // remonter a l'appelant, qui sait quoi en faire.
    //
    // Sans ce garde, le tunnel de paiement fusionne devenait inutilisable : un
    // invite qui arrive sur /checkout declenche l'appel panier, qui repond 401,
    // dont le rafraichissement echoue faute de jeton — et il se faisait ejecter
    // sur /login au lieu de voir le formulaire.
    if (!refreshToken) {
      return Promise.reject(error);
    }

    try {
      const response = await axios.post(`${process.env.NEXT_PUBLIC_SOCKET}/api/user/refresh-token`, { refreshToken });
      if (response.status === 200) {
        const { access_token, refresh_token } = response.data;
        localStorage.setItem('access_token', access_token);
        localStorage.setItem('refresh_token', refresh_token);
        api.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
        originalRequest.headers['Authorization'] = `Bearer ${access_token}`;
        return api(originalRequest);
      }
    } catch (err) {
      console.error('Error refreshing token:', err);
      // Session morte : on la nettoie, on ne deporte pas.
      //
      // Cet intercepteur voit TOUS les appels, y compris ceux declenches sur
      // une page publique. Un jeton de rafraichissement perime traine dans le
      // localStorage, un appel 401 quelque part, et le visiteur se retrouvait
      // ejecte sur /login au milieu de sa reservation — depuis une fiche tour
      // comme depuis le tunnel de paiement.
      //
      // On efface donc la session et on laisse le 401 remonter a l'appelant,
      // qui sait quoi en faire. Les ecrans qui exigent un compte lisent
      // `auth.user`, qui vient de passer a null. Meme regle que dans
      // verifyToken.tsx, pour que les deux ne se contredisent pas.
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('user');
    }
  }
  return Promise.reject(error);
});

export default api;
